(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["concern-finder"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const rootSelector = '[data-concern-product-finder]';

    function getParts(root) {
      return {
        select: root.querySelector('[data-concern-select]'),
        button: root.querySelector('[data-finder-button]'),
        results: root.querySelector('[data-finder-results]'),
        status: root.querySelector('[data-finder-status]'),
        panels: Array.from(root.querySelectorAll('[data-collection-panel]'))
      };
    }

    function selectedPanel(parts) {
      return parts.panels.find((panel) => panel.dataset.collectionHandle === parts.select.value);
    }

    function updateButton(root) {
      const parts = getParts(root);
      if (!parts.select || !parts.button || !parts.results) return;
      parts.button.disabled = !selectedPanel(parts);
    }

    function initialize(root) {
      const parts = getParts(root);
      if (!parts.select || !parts.button || !parts.results) return;

      // Start hidden on first load and after a Theme Editor section re-render.
      parts.results.hidden = true;
      parts.panels.forEach((panel) => { panel.hidden = true; });
      parts.button.setAttribute('aria-expanded', 'false');
      if (parts.status) parts.status.textContent = '';
      parts.select.selectedIndex = 0;
      updateButton(root);
    }

    function reveal(root) {
      const parts = getParts(root);
      if (!parts.select || !parts.button || !parts.results) return;
      const target = selectedPanel(parts);
      if (!target) return;

      parts.panels.forEach((panel) => { panel.hidden = panel !== target; });
      parts.results.hidden = false;
      parts.button.setAttribute('aria-expanded', 'true');
      if (parts.status) parts.status.textContent = target.dataset.collectionTitle;
      return target;
    }

    function initializeWithin(container) {
      if (container.matches && container.matches(rootSelector)) initialize(container);
      container.querySelectorAll(rootSelector).forEach(initialize);
    }

    // Delegation survives section replacement and creates no per-section listeners.
    document.addEventListener('click', (event) => {
      const button = event.target.closest && event.target.closest('[data-finder-button]');
      if (!button || button.disabled) return;
      const root = button.closest(rootSelector);
      if (!root) return;
      event.preventDefault();
      reveal(root);
    });

    document.addEventListener('change', (event) => {
      if (!event.target.matches || !event.target.matches('[data-concern-select]')) return;
      const root = event.target.closest(rootSelector);
      if (root) updateButton(root);
    });

    document.addEventListener('shopify:section:load', (event) => {
      initializeWithin(event.target);
    });

    document.addEventListener('shopify:block:select', (event) => {
      const root = event.target.closest && event.target.closest(rootSelector);
      if (!root || !event.detail || !event.detail.blockId) return;
      const parts = getParts(root);
      if (!parts.select) return;

      const option = Array.from(parts.select.options).find((item) => item.dataset.blockId === String(event.detail.blockId));
      if (!option) {
        // An unconfigured block has a visible editor note instead of a panel.
        parts.results.hidden = true;
        parts.panels.forEach((panel) => { panel.hidden = true; });
        parts.button.setAttribute('aria-expanded', 'false');
        if (parts.status) parts.status.textContent = '';
        return;
      }

      parts.select.selectedIndex = option.index;
      updateButton(root);
      const panel = reveal(root);
      if (panel) panel.scrollIntoView({ behavior: 'auto', block: 'nearest' });
    });

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initializeWithin(document), { once: true });
    } else {
      initializeWithin(document);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  (() => {
    function quizTarget(button) {
      const requestedId = (button.dataset.quizTarget || '').trim();
      return requestedId
        ? document.getElementById(requestedId)
        : document.querySelector('[data-concern-product-finder], .concern-finder');
    }

    function scrollToQuiz(button, target, arriving = false) {
      if (!target || !target.isConnected) return;
      const mobileMenu = button.closest('[data-header-section]');
      const headerSection = mobileMenu && document.getElementById('shopify-section-' + mobileMenu.dataset.headerSection);
      const header = button.closest('header-element') || (headerSection && headerSection.querySelector('header-element')) || document.querySelector('header-element');
      const bounds = header ? header.getBoundingClientRect() : null;
      const headerOffset = bounds ? Math.max(0, bounds.bottom, bounds.height) : 0;
      const destination = Math.max(0, window.scrollY + target.getBoundingClientRect().top - headerOffset - 16);
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const temporaryTabindex = !target.hasAttribute('tabindex');
      if (temporaryTabindex) target.setAttribute('tabindex', '-1');
      target.focus({ preventScroll: true });
      if (temporaryTabindex) {
        target.addEventListener('blur', () => target.removeAttribute('tabindex'), { once: true });
      }
      window.scrollTo({ top: destination, behavior: arriving || reducedMotion ? 'auto' : 'smooth' });
    }

    // Delegation survives Header updates and relocation of the mobile menu.
    document.addEventListener('click', (event) => {
      const button = event.target.closest && event.target.closest('[data-header-quiz-button]');
      if (!button || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      if (button.target === '_blank' || button.hasAttribute('download')) return;
      // Away from home, let the real link navigate, even if this page has a finder.
      if (button.dataset.quizHomepage !== 'true') return;
      const target = quizTarget(button);
      if (!target) return;
      event.preventDefault();

      const drawer = button.closest('drawer-element');
      const drawerSide = button.closest('.drawer--side');
      const Drawer = customElements.get('drawer-element');
      if (button.hasAttribute('data-mobile-quiz-button') && drawer && drawerSide && Drawer && typeof Drawer.close === 'function' && Drawer.status !== 'closed') {
        const closedEvent = 'theme:drawer:' + drawerSide.dataset.side + ':closed';
        let completed = false;
        let fallback;
        const finish = () => {
          if (completed) return;
          completed = true;
          clearTimeout(fallback);
          window.removeEventListener(closedEvent, finish);
          requestAnimationFrame(() => scrollToQuiz(button, target));
        };
        window.addEventListener(closedEvent, finish, { once: true });
        fallback = setTimeout(finish, 1200);
        Drawer.close();
      } else {
        scrollToQuiz(button, target);
      }
    });

    function scrollFromHomepageLink() {
      if (!window.location.hash) return;
      let hash;
      try { hash = decodeURIComponent(window.location.hash.slice(1)); } catch { return; }
      const buttons = document.querySelectorAll('[data-header-quiz-button][data-quiz-homepage="true"]');
      const button = Array.from(buttons).find(item => hash === (item.dataset.quizTarget || 'skin-gym-finder'));
      if (!button) return;
      const target = quizTarget(button);
      if (target) requestAnimationFrame(() => scrollToQuiz(button, target, true));
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', scrollFromHomepageLink, { once: true });
    } else {
      scrollFromHomepageLink();
    }
    window.addEventListener('hashchange', scrollFromHomepageLink);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["led-product-spotlight"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initialize(root) {
    if (root.dataset.sliderReady) return;
    root.dataset.sliderReady = 'true';
    const slides = Array.from(root.querySelectorAll('[data-slide]'));
    const buttons = Array.from(root.querySelectorAll('[data-slide-target]'));
    const media = root.querySelector('.led-spotlight__media');
    const points = Array.from(root.querySelectorAll('[data-benefit-point]'));
    const mobile = window.matchMedia('(max-width: 639px)');
    function syncPoints() {
      points.forEach(point => { point.open = !mobile.matches; });
    }
    syncPoints();
    mobile.addEventListener('change', syncPoints);
    root.addEventListener('shopify:section:unload', () => mobile.removeEventListener('change', syncPoints), { once: true });
    points.forEach(point => {
      point.querySelector('summary').addEventListener('click', event => {
        if (!mobile.matches) event.preventDefault();
      });
    });
    let current = 0;
    function show(index) {
      if (!slides.length) return;
      current = (index + slides.length) % slides.length;
      slides.forEach((slide, i) => { slide.hidden = i !== current; });
      buttons.forEach(button => {
        button.setAttribute('aria-pressed', String(button.dataset.slideTarget === slides[current].dataset.blockId));
      });
    }
    buttons.forEach(button => button.addEventListener('click', () => {
      show(slides.findIndex(slide => slide.dataset.blockId === button.dataset.slideTarget));
    }));
    media.addEventListener('keydown', event => {
      if (!event.target.closest('[data-slide-target]')) return;
      if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
      event.preventDefault();
      show(current + (event.key === 'ArrowRight' ? 1 : -1));
      if (buttons[current]) buttons[current].focus();
    });
    let startX = null;
    let startY = null;
    media.addEventListener('touchstart', event => {
      if (event.touches.length !== 1 || event.target.closest('button')) return;
      startX = event.touches[0].clientX;
      startY = event.touches[0].clientY;
    }, { passive: true });
    media.addEventListener('touchend', event => {
      if (startX === null || !event.changedTouches.length) return;
      const dx = event.changedTouches[0].clientX - startX;
      const dy = event.changedTouches[0].clientY - startY;
      if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy)) show(current + (dx < 0 ? 1 : -1));
      startX = startY = null;
    }, { passive: true });
    media.addEventListener('touchcancel', () => { startX = startY = null; }, { passive: true });
    root.addEventListener('shopify:block:select', event => {
      const index = slides.findIndex(slide => slide.dataset.blockId === event.detail.blockId);
      if (index >= 0) show(index);
      const point = event.target.closest('[data-benefit-point]');
      if (point) point.open = true;
    });
  }
  function scan(scope) {
    if (scope.matches && scope.matches('.led-spotlight')) initialize(scope);
    scope.querySelectorAll('.led-spotlight').forEach(initialize);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => scan(document), { once: true });
  else scan(document);
  document.addEventListener('shopify:section:load', event => scan(event.target));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-benefits-spotlight"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initialize(root) {
    if (root.dataset.sliderReady) return;
    root.dataset.sliderReady = 'true';
    const slides = Array.from(root.querySelectorAll('[data-slide]'));
    const buttons = Array.from(root.querySelectorAll('[data-slide-target]'));
    const media = root.querySelector('.product-benefits__media');
    const points = Array.from(root.querySelectorAll('[data-benefit-point]'));
    const mobile = window.matchMedia('(max-width: 639px)');
    function syncPoints() {
      points.forEach(point => { point.open = !mobile.matches; });
    }
    syncPoints();
    mobile.addEventListener('change', syncPoints);
    root.addEventListener('shopify:section:unload', () => mobile.removeEventListener('change', syncPoints), { once: true });
    points.forEach(point => {
      point.querySelector('summary').addEventListener('click', event => {
        if (!mobile.matches) event.preventDefault();
      });
    });
    let current = 0;
    function show(index) {
      if (!slides.length) return;
      current = (index + slides.length) % slides.length;
      slides.forEach((slide, i) => { slide.hidden = i !== current; });
      buttons.forEach(button => {
        button.setAttribute('aria-pressed', String(button.dataset.slideTarget === slides[current].dataset.blockId));
      });
    }
    buttons.forEach(button => button.addEventListener('click', () => {
      show(slides.findIndex(slide => slide.dataset.blockId === button.dataset.slideTarget));
    }));
    media.addEventListener('keydown', event => {
      if (!event.target.closest('[data-slide-target]')) return;
      if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
      event.preventDefault();
      show(current + (event.key === 'ArrowRight' ? 1 : -1));
      if (buttons[current]) buttons[current].focus();
    });
    let startX = null;
    let startY = null;
    media.addEventListener('touchstart', event => {
      if (event.touches.length !== 1 || event.target.closest('button')) return;
      startX = event.touches[0].clientX;
      startY = event.touches[0].clientY;
    }, { passive: true });
    media.addEventListener('touchend', event => {
      if (startX === null || !event.changedTouches.length) return;
      const dx = event.changedTouches[0].clientX - startX;
      const dy = event.changedTouches[0].clientY - startY;
      if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy)) show(current + (dx < 0 ? 1 : -1));
      startX = startY = null;
    }, { passive: true });
    media.addEventListener('touchcancel', () => { startX = startY = null; }, { passive: true });
    root.addEventListener('shopify:block:select', event => {
      const index = slides.findIndex(slide => slide.dataset.blockId === event.detail.blockId);
      if (index >= 0) show(index);
      const point = event.target.closest('[data-benefit-point]');
      if (point) point.open = true;
    });
  }
  function scan(scope) {
    if (scope.matches && scope.matches('.product-benefits')) initialize(scope);
    scope.querySelectorAll('.product-benefits').forEach(initialize);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => scan(document), { once: true });
  else scan(document);
  document.addEventListener('shopify:section:load', event => scan(event.target));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shop-by-concerns"] && !Shopify.designMode) return;
  try {
    
(function () {
  document.addEventListener('shopify:block:select', event => {
    const card = event.target.closest('[data-concern-card]');
    if (!card || !card.closest('.shop-concerns') || !window.matchMedia('(max-width: 639px)').matches) return;
    const track = card.closest('.shop-concerns__track');
    const distance = card.getBoundingClientRect().left - track.getBoundingClientRect().left - 18;
    track.scrollBy({ left: distance, behavior: 'auto' });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonial-media-spotlight"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init(root) {
    if (root.dataset.testimonialReady) return;
    root.dataset.testimonialReady = 'true';
    const slides = Array.from(root.querySelectorAll('[data-testimonial-slide]'));
    const buttons = Array.from(root.querySelectorAll('[data-testimonial-target]'));
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    let current = 0;
    let visible = false;
    const navigation = root.querySelector('.testimonial-spotlight__navigation');
    const pausedByUser = new WeakSet();
    function play(video) { const request = video.play(); if (request) request.catch(() => {}); }
    function syncVideo() {
      slides.forEach((slide, index) => {
        const video = slide.querySelector('video');
        if (!video) return;
        if (index !== current || !visible || reducedMotion.matches || document.hidden || pausedByUser.has(video)) video.pause();
        else play(video);
      });
    }
    slides.forEach(slide => {
      const video = slide.querySelector('video');
      const toggle = slide.querySelector('[data-video-toggle]');
      if (!video || !toggle) return;
      video.controls = false;
      video.muted = true;
      toggle.hidden = false;
      const update = () => {
        toggle.setAttribute('aria-label', video.paused ? 'Play video' : 'Pause video');
        toggle.querySelector('span').textContent = video.paused ? '▶' : 'Ⅱ';
      };
      video.addEventListener('play', update);
      video.addEventListener('pause', update);
      toggle.addEventListener('click', () => {
        if (video.paused) { pausedByUser.delete(video); play(video); }
        else { pausedByUser.add(video); video.pause(); }
      });
      update();
    });
    function show(index) {
      if (!slides.length) return;
      current = (index + slides.length) % slides.length;
      slides.forEach((slide, i) => { slide.hidden = i !== current; });
      buttons.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.testimonialTarget === slides[current].dataset.blockId)));
      if (navigation) slides[current].querySelector('.testimonial-spotlight__media').appendChild(navigation);
      syncVideo();
    }
    if (navigation && slides.length) slides[0].querySelector('.testimonial-spotlight__media').appendChild(navigation);
    buttons.forEach(button => button.addEventListener('click', () => show(slides.findIndex(slide => slide.dataset.blockId === button.dataset.testimonialTarget))));
    root.addEventListener('keydown', event => {
      if (!event.target.closest('[data-testimonial-target]') || !['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
      event.preventDefault(); show(current + (event.key === 'ArrowRight' ? 1 : -1));
      buttons[current].focus();
    });
    root.addEventListener('shopify:block:select', event => {
      const index = slides.findIndex(slide => slide.dataset.blockId === event.detail.blockId);
      if (index >= 0) show(index);
    });
    const observer = new IntersectionObserver(entries => {
      visible = entries[0].isIntersecting;
      if (visible) syncVideo();
      else root.querySelectorAll('video').forEach(video => video.pause());
    }, { threshold: .15 });
    observer.observe(root);
    document.addEventListener('visibilitychange', syncVideo);
    reducedMotion.addEventListener('change', syncVideo);
    root.addEventListener('shopify:section:unload', () => {
      observer.disconnect();
      document.removeEventListener('visibilitychange', syncVideo);
      reducedMotion.removeEventListener('change', syncVideo);
      root.querySelectorAll('video').forEach(video => video.pause());
    }, { once: true });
  }
  function scan(scope) {
    if (scope.matches && scope.matches('.testimonial-spotlight')) init(scope);
    scope.querySelectorAll('.testimonial-spotlight').forEach(init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => scan(document), { once: true });
  else scan(document);
  document.addEventListener('shopify:section:load', event => scan(event.target));
})();

  } catch(e) { console.error(e); }
})();
})();
